import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=19e7eccc&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=19e7eccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7eccc",
  null
  
)

export default component.exports